import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Setup Analytics script for production version
 * @type {string}
 */
const scriptTag1 = `<script async src="https://www.googletagmanager.com/gtag/js?id=UA-109797181-1"></script>`;
const scriptTag2 = `<script>window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());
gtag('config', 'UA-109797181-1');
</script>`;

if (environment.production) {
  enableProdMode();
  document.write(scriptTag1);
  document.write(scriptTag2);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/main.ts